var exports = {
  "S": "xe533113f--74f7f4--show-more",
  "V": "xe533113f--74f7f4--show-more-btn",
};

module.exports = exports;
